// Port of ios/Sources/ViewModels/SlashCommandComposer.swift.
//
// The pure half of slash commands (shared/API.md §15), mirroring `MentionComposer`'s shape so
// both autocomplete strips derive the same way and both are unit-testable.

/** One entry of `GET /teams/{id}/commands/autocomplete` (ios/Sources/Models/SlashCommand.swift). */
export interface SlashCommand {
  trigger: string;
  autoCompleteHint: string;
  autoCompleteDesc: string;
}

/**
 * A message is a command attempt when it starts with exactly one "/" — "//x" is how
 * Mattermost itself lets users literally SAY "/x" without running it.
 */
export function isCommandMessage(text: string): boolean {
  return text.startsWith('/') && !text.startsWith('//') && [...text].length > 1;
}

/**
 * The trigger being typed, or null once the trigger is complete (a space ends it — from there
 * the user is typing arguments and a suggestion strip would only cover the conversation).
 */
export function activeQuery(text: string): string | null {
  if (!text.startsWith('/') || text.startsWith('//')) return null;
  if (text.includes(' ')) return null;
  return text.slice(1);
}

/** Prefix-filtered, alphabetical, capped — a strip taller than a few rows covers the chat. */
export function filter(commands: readonly SlashCommand[], query: string, limit = 6): SlashCommand[] {
  const needle = query.toLowerCase();
  return commands
    .filter((c) => c.trigger.toLowerCase().startsWith(needle))
    .sort((a, b) => (a.trigger < b.trigger ? -1 : a.trigger > b.trigger ? 1 : 0))
    .slice(0, limit);
}

/** Applies a picked suggestion: the whole draft becomes "/trigger " ready for arguments. */
export function apply(trigger: string): string {
  return '/' + trigger + ' ';
}
